import wixLocationFrontend from 'wix-location-frontend';
import { session } from 'wix-storage-frontend';

$w.onReady(function () {
    goTo()
    setUtm()
});

function goTo() {
    $w('#homeBTN, #homeBTN2').link = '/get-started?unit=House';
    $w('#aduBTN, #aduBTN2').link = '/get-started?unit=ADU';
    $w('#officeBTN, #officeBTN2').link = '/get-started?unit=Office';
}

function setUtm() {
    let query = wixLocationFrontend.query;
    console.log('utm', query);
    const currentParams = session.getItem('queryParams')
    console.log('current parm', currentParams)
    if (currentParams === null) {
        session.setItem('queryParams', JSON.stringify(query));
    } else {
        const savedParams = currentParams || '{}';
        console.log('param saved', savedParams);
        wixLocationFrontend.queryParams.add(JSON.parse(savedParams))
    }
}